import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppService } from '../../../services/app.service';
import { UtilsService } from '../../../services/utils.service';
import { AuthService } from '../../../services/auth.service';
import { UserService } from '../../../services/users.service';
import { VirtualCardsService } from '../../../services/virtual_cards.service';
import { PaymentDeclarationsService } from '../../../services/payment_declarations.service';
import { TransactionsService } from '../../../services/transactions.service';

@Component({
  selector: 'app-add-payment-declaration',
  templateUrl: './add-payment-declaration.component.html',
  styleUrl: './add-payment-declaration.component.scss',
})
export class AddPaymentDeclarationComponent {
  @Input() symbol: any;
  @Input() token: any;
  @Input() type: any;
  @Input() amount: any;
  @Input() wallet: any;

  currencyType: any;

  showDeclarePaymentModal = false;
  declaring = false;
  selectedNetwork: any = null;
  selectedToken: any = null;

  paymentForm = this.formBuilder.group({
    amount: [null, Validators.required],
    reference: ['', Validators.required],
  });

  constructor(
    private formBuilder: FormBuilder,
    public utilsService: UtilsService,
    private messageService: MessageService,
    public auth: AuthService,
    public appService: AppService,
    public userService: UserService,
    private paymentDeclarationService: PaymentDeclarationsService,
    private transactionService: TransactionsService,
  ) {}

  ngOnInit() {
    this.currencyType = this.utilsService.getCurrencyKind(
      this.token,
      this.appService.config?.currencies,
    );

    this.showDeclarePaymentModal = true;
    this.paymentForm = this.formBuilder.group({
      amount: [this.amount, Validators.required],
      reference: ['', Validators.required],
    });
  }

  declarePayment = () => {
    if (!this.auth.guardTransactionalAction()) return;
    if (this.declaring) return;
    this.declaring = true;
    let body = {
      currency: this.token,
      amount: this.paymentForm.controls.amount.value,
      wallet: this.wallet ? this.wallet : this.symbol,
      reference: this.paymentForm.controls.reference.value,
      type: this.type,
    };

    if (this.currencyType == 'crypto')
      this.paymentDeclarationService.postPaymentDeclaration(body).then(
        (resp: any) => {
          this.declaring = false;
          this.messageService.add({
            severity: 'success',
            summary: 'Listo',
            detail: 'Hemos creado tu recarga exitosamente.',
          });

          this.appService.triggerAddCashin(false);
          this.appService.triggerAddPayment(false);
          this.appService.triggerViewWallets(false);

          this.showDeclarePaymentModal = false;
        },
        () => {
          this.declaring = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Ocurrió un error al registrar tu recarga.',
          });
        },
      );
    else {
      let cashinBody = {
        reference: this.paymentForm.controls.reference.value,
        metadata: JSON.stringify(body),
        destiny_wallet_id: this.wallet,
        amount: this.amount,
        provider_service_id: 2,
        client_id: this.auth.user.user_id,
        type: 'cashin',
        status: 'validating',
      };

      this.addCashin(cashinBody);
    }
  };

  getValue() {
    return this.paymentForm.controls.amount.value
      ? Number(this.paymentForm.controls.amount.value) * 0.99
      : 0;
  }

  addCashin(body: any) {
    this.transactionService.addCashin(body).subscribe(
      () => {
        this.declaring = false;

        this.appService.triggerAddCashin(false);
        this.appService.triggerAddPayment(false);
        this.appService.triggerViewWallets(false);

        this.showDeclarePaymentModal = false;
        this.messageService.add({
          severity: 'success',
          summary: 'Listo',
          detail:
            'Hemos creado la declaración de la recarga a tu cuenta correctamente.',
        });
      },
      () => {
        this.declaring = false;

        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: `Ocurrió un error al declarar la recargar a tu cuenta, por favor intenta nuevamente. `,
        });
      },
    );
  }

  exit() {
    this.appService.triggerAddPayment(false);
  }
}
